import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Alert } from 'react-bootstrap';
import { FaEnvelope, FaLock, FaSignInAlt } from 'react-icons/fa';
import { toast } from 'react-toastify';

// IMPORTAÇÕES NOVAS
import { AuthContext } from "../../contexts/AuthContext";

// Estilos e Imagens (Mantidos iguais)
import '../../responsive.css';
import logoBranca from '../../assets/logo-branca.png';

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  
  const navigate = useNavigate();
  
  // Pega a função 'signIn' (Entrar) e a função 'signOut' (Sair) que criamos no AuthContext
  const { signIn, signOut } = useContext(AuthContext);

  // EFEITO DE LOGOUT: Ao entrar na tela de Login, garante que o usuário está deslogado
  useEffect(() => {
    signOut();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    
    if (!email || !senha) {
      setErro('Por favor, preencha todos os campos');
      return;
    }

    setCarregando(true);

    try {
      // Chama a função do Contexto. Ela bate no seu Node.js (na rota /sessions) e salva o token!
      const loginSucesso = await signIn(email, senha);

      if (loginSucesso) {
        toast.success("Bem-vindo de volta!");
        // Redireciona pro Dashboard!
        navigate("/dashboard", { replace: true });
      } else {
        // Se a função retornar false, é porque deu algum erro no back-end (senha errada, etc)
        setErro("Não foi possível acessar. Verifique suas credenciais.");
      }
    } catch (err) {
      console.error(err);
      setErro("Ocorreu um erro inesperado.");
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src={logoBranca} alt="Logo Maxtra Mídia" className='img-logo'/>
        </div>
        <div className="login-body">
          <h3 className="login-title">Login</h3>
          
          {erro && (
            <Alert variant="danger" className="mb-3">
              {erro}
            </Alert>
          )}
          
          <Form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                <FaEnvelope className="me-2" /> Email
              </label>
              <input
                type="email"
                id="email"
                className="form-control"
                placeholder="Seu email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="senha" className="form-label">
                <FaLock className="me-2" /> Senha
              </label>
              <input
                type="password"
                id="senha"
                className="form-control"
                placeholder="Sua senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
              />
            </div>
            
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="lembrar"
                />
                <label className="form-check-label" htmlFor="lembrar">
                  Lembrar-me
                </label>
              </div>
              <Link to="/esqueci-senha" className="text-primary">
                Esqueceu a senha?
              </Link>
            </div>
            
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={carregando}
            >
              {carregando ? (
                'Entrando...'
              ) : (
                <>
                  <FaSignInAlt className="me-2" /> Entrar
                </>
              )}
            </button>
          </Form>
        </div>
        <div className="login-footer">
          <p className="mb-0">
            © {new Date().getFullYear()} Maxtra Mídia
          </p>
        </div>
      </div>
    </div>
  );
}
